import type React from 'react';
import { Route, Routes } from 'react-router-dom';
import { PrivateRoute } from '../components/PrivateRoute';
import type { DrawerContentData } from '../components/RightDrawer';
import { BusinessFlow } from '../pages/BusinessFlow';
import { HypothesisDetail } from '../pages/HypothesisDetail';
import { Organizations } from '../pages/Organizations';
import { PassiveScans } from '../pages/PassiveScans';
import { ProxyConfig } from '../pages/ProxyConfig';
import { Settings } from '../pages/Settings';
import { SpecificationDetail, Specifications } from '../pages/Specifications';
import { Strategies } from '../pages/Strategies';
import { TestDetail } from '../pages/TestDetail';
import { TestExecution } from '../pages/TestExecution';
import { TestHypotheses } from '../pages/TestHypotheses';
import { Users } from '../pages/Users';
import { VulnerabilityDetail } from '../pages/VulnerabilityDetail';
import { VulnerabilityManagement } from '../pages/VulnerabilityManagement';

interface AppRoutesProps {
  onOpenRightDrawer: (content: DrawerContentData) => void;
}

export const AppRoutes: React.FC<AppRoutesProps> = ({ onOpenRightDrawer }) => (
  <Routes>
    <Route
      path="/"
      element={
        <PrivateRoute requiredPermission="schemas.read">
          <Specifications />
        </PrivateRoute>
      }
    />
    <Route
      path="/specifications"
      element={
        <PrivateRoute requiredPermission="schemas.read">
          <Specifications />
        </PrivateRoute>
      }
    />
    <Route
      path="/specifications/:schemaId"
      element={
        <PrivateRoute requiredPermission="schemas.read">
          <SpecificationDetail />
        </PrivateRoute>
      }
    />
    <Route
      path="/mle-config"
      element={
        <PrivateRoute>
          <ProxyConfig />
        </PrivateRoute>
      }
    />
    <Route
      path="/proxy-config"
      element={
        <PrivateRoute>
          <ProxyConfig />
        </PrivateRoute>
      }
    />
    <Route
      path="/business-flows"
      element={
        <PrivateRoute requiredPermission="strategies.read">
          <BusinessFlow onOpenRightDrawer={onOpenRightDrawer} />
        </PrivateRoute>
      }
    />
    <Route
      path="/passive-scans"
      element={
        <PrivateRoute>
          <PassiveScans />
        </PrivateRoute>
      }
    />
    <Route
      path="/test-hypotheses"
      element={
        <PrivateRoute>
          <TestHypotheses onOpenRightDrawer={onOpenRightDrawer} />
        </PrivateRoute>
      }
    />
    <Route
      path="/test-execution"
      element={
        <PrivateRoute requiredPermission="tests.execute">
          <TestExecution onOpenRightDrawer={onOpenRightDrawer} />
        </PrivateRoute>
      }
    />
    <Route
      path="/strategies"
      element={
        <PrivateRoute requiredPermission="strategies.read">
          <Strategies />
        </PrivateRoute>
      }
    />
    <Route
      path="/vulnerabilities"
      element={
        <PrivateRoute requiredPermission="vulnerabilities.read">
          <VulnerabilityManagement onOpenRightDrawer={onOpenRightDrawer} />
        </PrivateRoute>
      }
    />
    <Route
      path="/vulnerabilities/:id"
      element={
        <PrivateRoute requiredPermission="vulnerabilities.read">
          <VulnerabilityDetail />
        </PrivateRoute>
      }
    />
    <Route
      path="/hypotheses/:schemaId/:filename"
      element={
        <PrivateRoute>
          <HypothesisDetail />
        </PrivateRoute>
      }
    />
    <Route
      path="/tests/:schemaId/:filename"
      element={
        <PrivateRoute>
          <TestDetail />
        </PrivateRoute>
      }
    />
    <Route
      path="/settings"
      element={
        <PrivateRoute>
          <Settings onOpenRightDrawer={onOpenRightDrawer} />
        </PrivateRoute>
      }
    />
    <Route
      path="/organizations"
      element={
        <PrivateRoute requiredPermission="organizations.read">
          <Organizations />
        </PrivateRoute>
      }
    />
    <Route
      path="/users"
      element={
        <PrivateRoute requiredPermission="users.read">
          <Users />
        </PrivateRoute>
      }
    />
  </Routes>
);
